import "swiper/css";
import "swiper/css/pagination";
import { Container } from "@mui/material";
import { EffectCreative, Pagination, Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import React from "react";

import "./homePage.scss";

const CaseStudies = () => {
  const data = [
    {
      image:
        "https://d5r8zwzwkh326.cloudfront.net/new+ui+images/home+page/Case-studies/stanza.png",
      title:
        "Settlrs: Fuelling growth with PAN India services for Co-living stars",
      id: "stanza",
    },
    {
      image:
        "https://d5r8zwzwkh326.cloudfront.net/new+ui+images/home+page/Case-studies/Hopstack.png",
      title: "Empowering remote workforce with seamless MacBook solutions",
      id: "hopstack",
    },
    {
      image:
        "https://d5r8zwzwkh326.cloudfront.net/new+ui+images/home+page/Case-studies/settle.png",
      title:
        "Forging path to premium living for hostelers: A visionary co-living partnership",
      id: "settl",
    },
    {
      image:
        "https://d5r8zwzwkh326.cloudfront.net/new+ui+images/home+page/Case-studies/yourspace.png",
      title:
        "Settlrs: Transforming co-living experience for young professionals",
      id: "yourspace",
    },
    {
      image:
        "https://d5r8zwzwkh326.cloudfront.net/new+ui+images/home+page/Case-studies/sony.png",
      title: "Sony-Settlrs partnership: Redefining premium living in Bangalore",
      id: "sony",
    },
    {
      image:
        "https://d5r8zwzwkh326.cloudfront.net/new+ui+images/home+page/Case-studies/Aquatein.png",
      title:
        "Revolutionizing commercial refrigeration: Aquatein's brand growth with Settlrs",
      id: "aquatein",
    },
  ];

  return (
    <div className="case-studeis-container">
      <h2 className="c-s-title">Case Studies</h2>
      <div className="c-s-carousel-container">
        <Container maxWidth="lg">
          <Swiper
            pagination={{ clickable: true }}
            modules={[Pagination, EffectCreative, Autoplay]}
            className="mySwiper"
            effect={"creative"}
            creativeEffect={{
              prev: {
                shadow: true,
                translate: [0, 0, -400],
              },
              next: {
                translate: ["100%", 0, 0],
              },
            }}
            autoplay={{ delay: 4000 }}
          >
            {data.map((item, index) => (
              <SwiperSlide key={index}>
                <div className="case-studies-list">
                  <div className="c-s-image">
                    <img src={item.image} alt="" loading="lazy" />
                  </div>
                  <div className="c-s-content">
                    <p style={{ color: "#474444" }}>{item.title}</p>
                    <span
                      style={{
                        color: "#e96c4c",
                        fontSize: "1.5rem",
                      }}
                    >
                      <a href={`/case-studies?case=${item.id}`}>Read more</a>
                    </span>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </Container>
      </div>
    </div>
  );
};

export default CaseStudies;
